import { render, staticRenderFns } from "./PeoplePlusIcon.vue?vue&type=template&id=cb4c6472&"
import script from "./PeoplePlusIcon.vue?vue&type=script&lang=ts&"
export * from "./PeoplePlusIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports